import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TextEditorService} from '../shared/services/text-editor.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-edit-cultural-initiative-sleep',
  templateUrl: './edit-cultural-initiative-sleep.component.html',
  styleUrls: ['./edit-cultural-initiative-sleep.component.css']
})
export class EditCulturalInitiativeSleepComponent implements OnInit {
  @Input() content: string;
  @Output() newItemEvent = new EventEmitter<string>();
  editorConfig;

  constructor(
    private textEditorService: TextEditorService,
  ) {
  }

  ngOnInit(): void {
    this.editorConfig = this.textEditorService.editorConfig;
  }

  contentChanged(): void {
    this.newItemEvent.emit(this.content);
  }
}
